import { createAction, props } from "@ngrx/store";
import { AppointmentDto } from "../interfaces/appointment_dto";
import { SendAppointmentRequest } from "../interfaces/send_appointment_request";
import { AppointmentAddRequest } from "../interfaces/appointment_add_request";
import { CalendarResourceDto } from "../interfaces/calendar_resource_dto";

export const changeCalendarView = createAction("[Calendar] Change View", props<{ view: string }>());

export const loadAppointments = createAction("[Calendar] Load Appointments");

export const loadAppointmentsSuccess = createAction(
  "[Calendar] Load Appointments Success",
  props<{ appointments: AppointmentDto[] }>()
);

export const loadAppointmentsFailure = createAction(
  "[Calendar] Load Appointments Failure",
  props<{ error: any }>()
);

export const loadUpcomingLessons = createAction(
  "[Calendar] Load Upcoming Lessons"
);

export const loadUpcomingLessonsSuccess = createAction(
  "[Calendar] Load Upcoming Lessons Success",
  props<{ lessons: AppointmentDto[] }>()
);

export const addLesson = createAction(
  "[Calendar] Add Appointment",
  props<{ lesson: AppointmentAddRequest, googleCalendarId?: string, localCalendarConnected?: boolean }>()
);

export const addLessonSuccess = createAction(
  "[Calendar] Add Appointment Success",
  props<{ lesson: AppointmentDto }>()
);

export const updateLesson = createAction(
  "[Calendar] Update Lesson",
  props<{ lesson: any, googleCalendarId?: string }>()
);

export const updateLessonSuccess = createAction(
  "[Calendar] Update Lesson Success",
  props<{ lesson: AppointmentDto }>()
);

export const deleteAppointment = createAction(
  "[Calendar] Delete Appointment",
  props<{ appointmentId: number, googleCalendarId?: string, googleId?: string, localCalendarId?: string }>()
);

export const deleteAppointmentSuccess = createAction(
  "[Calendar] Delete Appointment Success",
  props<{ appointment: AppointmentDto }>()
);

export const updateAppointment = createAction(
  "[Calendar] Update Appointment",
  props<{ appointment: AppointmentDto, googleCalendarId?: string, localCalendarId?: string }>()
);

export const updateAppointmentSuccess = createAction(
  "[Calendar] Update Appointment Success",
  props<{ appointment: AppointmentDto }>()
);

export const selectLesson = createAction(
  "[Lessons] Select Lesson",
  props<{ lesson: AppointmentDto }>()
);

export const sendAppointmentReminder = createAction(
  "[Calendar] Send Appointment Reminder",
  props<{ sendAppointmentRequest: SendAppointmentRequest }>()
);

export const sendAppointmentReminderSuccess = createAction(
  "[Calendar] Send Appointment Reminder Success",
  props<{ sendAppointmentRequest: SendAppointmentRequest }>()
);

export const upsertAppointments = createAction(
  "[Calendar] Upsert Appointments",
  props<{ appointments: AppointmentDto[] }>()
);

export const addCalendarResources = createAction(
  "[Calendar] Add Calendar Resources",
  props<{ resources: CalendarResourceDto[] }>()
);

export const addCalendarResourcesSuccess = createAction(
  "[Calendar] Add Calendar Resources Success",
  props<{ resources: CalendarResourceDto[] }>()
);

export const getCalendarResources = createAction(
  "[Calendar] Get Calendar Resources"
);

export const updateCalendarResource = createAction(
  "[Calendar] Update Calendar Resource",
  props<{ resource: CalendarResourceDto }>()
);

export const updateCalendarResourceSuccess = createAction(
  "[Calendar] Update Calendar Resource Success",
  props<{ resource: CalendarResourceDto }>()
);

export const getCalendarResourcesSuccess = createAction(
  "[Calendar] Get Calendar Resources Success",
  props<{ resources: CalendarResourceDto[] }>()
);

export const getGoogleEvents = createAction(
  "[Calendar] Get Google Events",
  props<{ googleCalendarId: string }>()
);

export const getGoogleEventsSuccess = createAction(
  "[Calendar] Get Google Events Success",
  props<{ events: AppointmentDto[] }>()
);

export const getLocalEvents = createAction(
  "[Calendar] Get Local Events",
  props<{ calendarId: string }>()
);

export const getLocalEventsSuccess = createAction(
  "[Calendar] Get Local Events Success",
  props<{ events: AppointmentDto[] }>()
);
